/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { AfterViewInit, ChangeDetectionStrategy, Component, ContentChildren, ElementRef, OnDestroy, QueryList } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fm-balloon-actions',
  templateUrl: './balloon-actions.component.html',
  styleUrls: ['./balloon-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BalloonActionsComponent implements AfterViewInit, OnDestroy {
  @ContentChildren('button', { read: ElementRef })
  public actions: QueryList<ElementRef>;

  private readonly _unsubscribe$ = new Subject<void>();

  public ngAfterViewInit(): void {
    this._setActionsClass();
    this.actions.changes.pipe(takeUntil(this._unsubscribe$)).subscribe(() => {
      this._setActionsClass();
    });
  }

  public ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  private _setActionsClass(): void {
    this.actions.forEach(action => action.nativeElement.classList.add('balloon-action'));
  }
}
